<div class="zmodal" [class.zmodal--show]="authService.changeCustomerDialog$ | async">
  <div class="zmodal__wrapper zmodal__wrapper--w100">
    <div class="zmodal__content zmodal__content--half">
      <app-change-customer-screen></app-change-customer-screen>
    </div>
  </div>
</div>
